import {
  isLandingSubpagePath,
  isPathLang,
  stripLangPrefix,
} from '@/seo/marketing-routes';

/**
 * The pages a first visit can open WITHOUT the signed-in app's code: the
 * landing (its feature and section URLs included) and About, in every language, and a
 * bare `/<lang>` (which only
 * redirects to its landing). They render in the landing shell
 * (`landing-shell.tsx`); every other path loads the app shell
 * (`app-shell.tsx`), and once it has loaded it serves these pages too.
 */
export function isLandingShellPath(pathname: string): boolean {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length === 1 && isPathLang(segments[0])) return true;
  const path = stripLangPrefix(pathname).replace(/\/+$/, '') || '/';
  return (
    path === '/' ||
    path === '/home' ||
    path === '/home/about' ||
    isLandingSubpagePath(path)
  );
}
